import React from 'react'
import { useEffect, useState, useRef } from "react";
import Select from "react-select";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import apiInstance from "../../utils/axios";
import formatIngredients from "../../utils/formatIngredients";
import UserData from "../plugins/UserData";
import '../../../css/product.css';
import { Link, useNavigate } from "react-router-dom";
// import { BASE_URL } from "../../utils/constant";
import { useAuthApp } from '../../app/auth';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import '../../../css/profile.css';
import useAxios from '../../utils/useAxios';
import imageCompression from 'browser-image-compression';
import { REACT_APP_ENV } from '../../utils/constant';

const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
});


function Profile() {
  const [userProfile, setUserProfile] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [imagePreview, setImagePreview] = useState('')
  const { t, i18n } = useTranslation();

  let lang_browser = navigator.language.toLowerCase();
  let lang = localStorage.getItem('language') || (lang_browser.startsWith("en") ? "en" : lang_browser);

  const [formData, setFormData] = useState({
          id: '',
          first_name: '',
          last_name: '',
          email: '',
          phone_nr: null,
          winefactsprofile: {
              id: '',
              acceptance: null,
              img_qr_code:'',
              winery:'',
          }
      });

  const userData = useAuthApp((state) => state.user)
  const userId = userData()?.user_id
  const navigate = useNavigate()
  const api=useAxios();

  const fetchProfileData = async () => {
    if (!api) return; // Check if api is defined
    try {
      const response = await api.get(`user/${userId}/`)
      delete response.data.hashed_id
      setFormData(response.data);
      if (response.data?.winefactsprofile?.img_qr_code) {
        setImagePreview(response.data?.winefactsprofile?.img_qr_code);
      } 
    } catch (error) {
      console.log(error)
      navigate("/login");
      Toast.fire({
        icon: "error",
        title: t("userProfile.messages.fetchError"),
      })
      
    }
    
  }

  useEffect(() => {
    if (api) {
      fetchProfileData()
    }
  },[api, i18n.language])

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
    };

    try {
        const compressedBlob = await imageCompression(file, options);
        // Convert Blob to File and preserve the original file name and type
        const compressedFile = new File(
            [compressedBlob],
            file.name,
            { type: compressedBlob.type }
        );

        if (compressedFile) {
            const reader = new FileReader();
            reader.onload = () => {
                setImagePreview(reader.result); // Set the preview URL
            };
            reader.readAsDataURL(compressedFile); // Read the file as a data URL
        }

        setFormData((prev) => ({
            ...prev,
            winefactsprofile: {
              ...prev.winefactsprofile, // Spread the previous winefactsprofile
              img_qr_code: compressedFile},
        }));
    } catch (error) {
        console.error("Image compression error:", error);
    }
  };

  const handleChange = (e) => {

    if (e.target.name === 'img_qr_code' || e.target.name === 'winery') {
      setFormData((prev) => ({
        ...prev,
        winefactsprofile: {
          ...prev.winefactsprofile,
          [e.target.name]: e.target.value
        }
      }))
    } else {
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value
      }))
    }    
  }

  const validateForm = (formData) => {
    if (formData.winefactsprofile.img_qr_code) {
        const fileSize = formData.winefactsprofile.img_qr_code.size / 1024 / 1024; // Convert size to MB

        if (fileSize > 10) {
          setIsLoading(false);                   
          Toast.fire({
              icon: "error",
              title: t("userProfile.messages.profilePictureSizeWarning"),
          });
          return false;
        }
    }

    if (!formData.first_name ||
        !formData.last_name ||
        !formData.email ||
        !formData.winefactsprofile.winery
    ) {
        setIsLoading(false)
        return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true)

    if (!validateForm(formData)){
      setIsLoading(false);
      return
    }

    const formDataToSend = new FormData();
    formDataToSend.append('first_name', formData.first_name);
    formDataToSend.append('last_name', formData.last_name);
    formDataToSend.append('email', formData.email);
    if (formData?.phone_nr) {
      formDataToSend.append('phone_nr', formData?.phone_nr);
    }

    if (formData.winefactsprofile) {
      formDataToSend.append('winefactsprofile[winery]', formData.winefactsprofile.winery);
      formDataToSend.append('winefactsprofile[acceptance]', formData.winefactsprofile.acceptance);
      if (formData.winefactsprofile.img_qr_code instanceof File) {
        formDataToSend.append('winefactsprofile[img_qr_code]', formData.winefactsprofile.img_qr_code);
      }
    }

    const response = await apiInstance.patch(`user/${userId}/update/`,  formDataToSend, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: REACT_APP_ENV == 'DEV' ? 100000 : 15000
    })

    if (response.status === 200) {
        Toast.fire({
            icon: "success",
            title: t("userProfile.messages.formSubmitted"),
        })

        fetchProfileData()
        setIsLoading(false)
  } else {
      console.error(t("userProfile.messages.formSubmissionError"));
      Toast.fire({
          icon: "error",
          title: t("userProfile.messages.formSubmissionError"),
      })
      setIsLoading(false)
    }
  }

  const handleDeleteImage = async () => {
    setIsLoading(true);
    try {
      const response = await api.post(`user/${userId}/delete-qr-image/`);
      if (response.status === 200) {
        setImagePreview('');
        setFormData(prev => ({
          ...prev,
          winefactsprofile: {
            ...prev.winefactsprofile,
            img_qr_code: ''
          }
        }));
        Toast.fire({
          icon: "success",
          title: t("userProfile.messages.qrImageDeleted"),
        });
      }
    } catch (error) {
      Toast.fire({
        icon: "error",
        title: t("userProfile.messages.qrImageDeleteError"),
      });
    } finally {
      setIsLoading(false);
    }            
  }

  return (
    <>
      <div className="container">
        <p className="form-heading-1">{t("userProfile.headings.title")}</p>
        <p className="desc-text">{t("userProfile.headings.description")}</p>
        <form className="form-width-1" onSubmit={handleSubmit}>
          <div className="form-input-container-1">
              <label htmlFor="first_name" className="form-label-1 no-margin">{t("userProfile.labels.firstName")}</label>
              <input
                  id="first_name"
                  name="first_name"
                  className="form-input-2"
                  value={formData.first_name}
                  onChange={(e) => handleChange(e)}
                  placeholder=""
                  type="text"
              />
          </div>

          <div className="form-input-container-1">
              <label htmlFor="last_name" className="form-label-1 no-margin">{t("userProfile.labels.lastName")}</label>
              <input
                  id="last_name"
                  name="last_name"
                  className="form-input-2"
                  value={formData.last_name}
                  onChange={(e) => handleChange(e)}
                  placeholder=""
                  type="text"
              />
          </div>

          <div className="form-input-container-1">
              <label htmlFor="email" className="form-label-1 no-margin">{t("userProfile.labels.email")}</label>
              <input
                  id="email"
                  name="email"
                  className="form-input-2"
                  value={formData.email}
                  onChange={(e) => handleChange(e)}
                  placeholder=""
                  type="email"
              />
          </div>

          <div className="form-input-container-1">
              <label htmlFor="phone_nr" className="form-label-1 no-margin">{t("userProfile.labels.mobile")}</label>
              <input
                  id="phone_nr"
                  name="phone_nr"
                  className="form-input-2"
                  value={formData.phone_nr}
                  onChange={(e) => handleChange(e)}
                  placeholder=""
                  type="text"
              />
          </div>

          <div className="form-input-container-1">
              <label htmlFor="winery" className="form-label-1 no-margin">{t("userProfile.labels.winery")}</label>
              <input
                  id="winery"
                  name="winery"
                  className="form-input-2"
                  value={formData.winefactsprofile.winery}
                  onChange={(e) => handleChange(e)}
                  placeholder=""
                  type="text"
              />
          </div>

          <div className="form-input-container-1">
            <label htmlFor="img_qr_code" className="file-label-2">
              <input
                  id="img_qr_code"
                  name="img_qr_code"
                  type="file"
                  className="file-input"
                  onChange={handleImageChange}                  
              />
              <span className="file-label-2-text">
                {formData.winefactsprofile.img_qr_code instanceof File
                  ? formData.winefactsprofile.img_qr_code.name
                  : t("userProfile.labels.uploadQRCodePicture")}
              </span>
            </label>

            {imagePreview && (
              <>
                <img src={imagePreview} alt="QR Code Preview" style={{ width: 100, height: 100, objectFit: "cover", marginLeft: 25 }} />
                <div>
                  <button
                    type="button"
                    className="file-label-2"
                    style={{ marginTop: "5px", marginBottom: "15px"}}
                    onClick={handleDeleteImage}
                  >
                    {t("userProfile.labels.deleteQRCodePicture")}
                  </button>
                </div>
              </>
            )}
          </div>

          <div className="form-input-container-1">
            <p className='font link-1'>
                <Link to="/change-password" className=''>{t("userProfile.links.changePassword")}</Link>
            </p>
          </div>
          
          <div className="form-input-container-3">
            {isLoading 
            ? <button disabled className="form-button-submit-1 w60pe" type="submit">
                <i className="fas fa-spinner fa-spin"></i>
                <span className="mr-2">Processing</span>
              </button>
            : <button className="form-button-submit-1 w60pe" type="submit"><span className="mr-2">Submit</span>
              </button>
            }
          </div>
        </form>
      </div>
    </>
  )
}

export default Profile